module.exports = __webpack_public_path__ + "static/media/loading img1.73c0ec7e.png";